import { defineSlotRecipe } from "@chakra-ui/react-v3";
import { pinInputAnatomy } from "@chakra-ui/react-v3/anatomy";

import { focusIndicator } from "theme/tokens/accessibility";

export const pinInputRecipe = defineSlotRecipe({
  slots: pinInputAnatomy.keys(),

  base: {
    control: {
      display: "inline-flex",
      gap: "2",
      isolation: "isolate",
    },

    input: {
      outline: "0",
      position: "relative",
      appearance: "none",
      // Matches the rendering from before the theme was owned, when Chakra's
      // default `outline` variant overrode an intended `bg.container`.
      bg: "transparent",
      color: "fg.default",
      border: "1px solid {colors.neutral.muted}",
      borderRadius: "lg",
      textAlign: "center",
      px: "1",

      _hover: {
        borderColor: "highlight.solid",
      },
      // Like the background, the focus colors preserve the effective result of
      // Chakra's `outline` variant over Tiger's `focusIndicator`.
      _focusVisible: {
        outline: "1px solid {colors.colorPalette.focusRing}",
        outlineOffset: "0",
        borderColor: "colorPalette.focusRing",
        boxShadow: focusIndicator.boxShadow,
      },
      _invalid: {
        borderColor: "error.solid",
      },
      _disabled: {
        borderColor: "neutral.emphasized",
        color: "fg.subtle",
        cursor: "default",
        opacity: 1,
      },
    },
  },

  variants: {
    size: {
      sm: {
        input: {
          w: "10",
          h: "11",
          textStyle: "heading.18",
          fontWeight: "bold",
        },
      },
      lg: {
        input: {
          w: "11",
          h: "14",
          textStyle: "heading.24",
          fontWeight: "bold",
        },
      },
    },
  },

  defaultVariants: {
    size: "sm",
  },
});
